module.exports = __webpack_public_path__ + "static/img/mould8-1.225cff5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould8-1.jpg
// module id = iOxs
// module chunks = 3